// extracted by mini-css-extract-plugin
export default {"video":"Uivideo_video__PLEVE"};